// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"502":"c3a71a48","5526":"ec52c4a3"}[chunkId] + ".chunk.css");